(function AgentVideoFilterForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentVideoFilter',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var selected_tab = '';
		var category_id  = '';

		$form.find("#agentvideofilter-category").on('change', function viewCategory() {
			localStorage.setItem('category_id', $("option:selected", this).val());

			selected_tab    = $('.current-video-tab').val();
			window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + $("option:selected", this).val();
		});

		$form.find("#agentvideofilter-subcategory").on('change', function viewCategory() {
			selected_tab    = $('.current-video-tab').val();
			category_id     = localStorage.getItem('category_id');
			window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + category_id + '/' + $("option:selected", this).val();
		});

		// $('#agentvideofilter-form_component_submit').on('submit', function _searchVideos(e) {
		// 	e.preventDefault();

		// 	Adzuki.Ajax.post('/Videos/index', $('#agentvideofilter-form_component_submit').serialize())
		// 		.then(function populateAgentVideos(response) {
		// 			// if (response) {
		// 				// TODO: see response
		// 				$form.submit();

		// 				// window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + category_id + '/' + $("option:selected", this).val();
		// 				// window.location = Adzuki.base_uri + '/Videos/index/' + selected_tab + '/' + category_id + '/';
		// 			// }
		// 		}
		// 	);
		// });

		$form.find("#agentvideofilter-category").on('change', function viewCategory() {
			var selected = $("option:selected", this).val();

			if (selected === 'all') {
				$('.subcategories').remove();
			}
		});

		Adzuki.Typeahead(
			'.vid-title-search',
			function search(term, display, $self)
			{
				var uri = '/Videos/typeaheadSearch/' + term;

				Adzuki.Ajax.get(uri)
					.then(function searchDisplay(response)
					{
						$self.removeClass('ajax-spinner');
						display(response);
					})
					.catch(function searchError()
					{
						$self.removeClass('ajax-spinner');
						display([{name: "Error searching for destinations."}]);
					}
				);
			},
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			},
			function template(item) {
				var html = item.name;
				return html;
			}
		);
	};
}(jQuery, window.Adzuki || {}));